import { render, staticRenderFns } from "./Reservations.vue?vue&type=template&id=7243c1ca"
import script from "./Reservations.js?vue&type=script&lang=js&external"
export * from "./Reservations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports